// apps/website/src/chat/headless.ts

import { useMemo } from 'react';
import { createFrontendActions, type FrontendToolContext } from '@dopomogai/chat-react';

export function useGlobalHeadlessContext(): FrontendToolContext {
  return useMemo<FrontendToolContext>(
    () => ({
      openSection: (id: string) => {
        const el = document.getElementById(id);
        if (!el) return { ok: false as const, error: `#${id} not found`, code: 'not_found' };
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return { ok: true as const };
      },
      safeNavigate: (path: string) => {
        if (typeof path === 'string' && path.startsWith('/')) {
          window.dispatchEvent(new CustomEvent('dg:navigate', { detail: { path } }));
          return { ok: true as const };
        }
        return { ok: false as const, error: 'Only internal paths allowed.', code: 'forbidden' };
      },
      selectPreset: (_id: string) => {},
      setFeature: (_id: string, _enabled: boolean) => {},
      setPersonalizedCopy: (_field: string, _value: string, _index?: number) => {},
      fillFormField: (_formId: string, _fieldId: string, _value: string) => {},
      submitLeadEmail: async (email: string) => {
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!valid) return { ok: false as const, error: 'Invalid email', code: 'invalid_email' };
        try {
          return { ok: true as const };
        } catch {
          return { ok: false as const, error: 'Network error', code: 'network' };
        }
      },
      openQuoteWithCurrentConfig: async () => ({ url: window.location.href }),
    }),
    [],
  );
}

export function useGlobalHeadlessTools(ctx: FrontendToolContext) {
  return useMemo(() => createFrontendActions(ctx, null, ['open_section', 'navigate']), [ctx]);
}
